export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetGroup(context) {
      context.commit("updateGroup", false)
    },
  },
  mutations: {
    updateGroup(state, data) {
      return state.data = data
    }
  }
}